import React, { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import GaugeChart from "react-gauge-chart";
import ScanMessage from "../common/scanningMessage";
import { useSelector, useDispatch } from "react-redux";
import "../../assets/css/recommendation-modal.css";
import {
  fetchSubDomains,
  fetchSubDomainsTotal,
  fetchSubDomainsGraph,
  fetchSubDomainsAction,
} from "../../actions/sub-domain";
import Pagination from "../Pagination/Pagination";
import { Tooltip as ReactTooltip } from "react-tooltip";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import BasicLineColumn from "../common/apexChart/basicLineColumn";
import AccessPage from "../Shared/accessPage";
import { API_URL } from "../../utils/constant";
import axios from "axios";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import $, { data } from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, isValid } from "date-fns";
import { fetchCustomerDomains } from "../../actions/customer";

const sliderStyles = `
  body.details-slider-open {
    overflow: hidden;
  }
  
  .details-slider-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  
  .details-slider-overlay.show {
    opacity: 1;
    pointer-events: all;
  }
  
  .details-slider-panel {
    position: fixed;
    top: 0;
    right: -600px;
    width: 600px;
    max-width: 90vw;
    height: 100%;
    background: #ffffff;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 1050;
    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  .details-slider-panel.open {
    right: 0;
  }
  
  .details-slider-content {
    background: #ffffff;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }
  
  .details-slider-header {
    background: #453acd;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  
  .details-slider-header h5 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
  
  .details-slider-close {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 18px;
  }
  
  .details-slider-close:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  .details-slider-action-btn {
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;
    outline: none;
  }
  
  .details-slider-action-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.5);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  
  .details-slider-action-btn:active {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  }
  
  .details-slider-action-btn i {
    font-size: 14px;
    color: white;
  }
  
  .details-slider-action-btn-text {
    color: white;
  }
  
  .details-slider-tabs {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    flex-shrink: 0;
  }
  
  .details-slider-tab {
    flex: 1;
    padding: 12px 20px;
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    color: #495057;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .details-slider-tab:hover {
    background: #e9ecef;
    color: #453acd;
  }
  
  .details-slider-tab.active {
    background: #ffffff;
    color: #453acd;
    border-bottom-color: #453acd;
  }
  
  .details-slider-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
  }
  
  .details-section {
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .details-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
  }
  
  .details-section-title i {
    color: #453acd;
    font-size: 1rem;
  }
  
  .details-info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f1f3f5;
  }
  
  .details-info-item:last-child {
    border-bottom: none;
  }
  
  .details-info-label {
    font-weight: 600;
    color: #495057;
    min-width: 140px;
    flex-shrink: 0;
    font-size: 0.9rem;
  }
  
  .details-info-value {
    color: #212529;
    flex: 1;
    word-break: break-word;
    font-size: 0.9rem;
  }
  
  @media (max-width: 768px) {
    .details-slider-panel {
      width: 100vw;
      right: -100vw;
    }
  }
`;

const Dashboard5 = () => {
  let subdomains = useSelector(
    (state) => state?.subDomain?.responseSsl?.data
  );
  let subdomainsTotals = useSelector(
    (state) => state?.subDomain?.subDomainSslTotal?.data
  );
  let subdomainCount = useSelector(
    (state) => state?.subDomain?.responseSsl
  );
  const scanCompleted = useSelector(
    (state) => state?.subDomain?.subDomainScanCompleted
  );
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);

  const [firstLoad, setFirstLoad] = useState(true);
  const [riskScore, setRiskScore] = useState("");

  const [expiryLoad, setExpiryLoad] = useState(true);
  const [riskExpiryScore, setExpiryRiskScore] = useState("");

  const [filterData, setfilterData] = useState("all");
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const [domain, setDomain] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [action, setAction] = useState("");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [limit, setLimit] = useState(10);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [activeTab, setActiveTab] = useState('info');
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');


  const myRef = useRef(null);

  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  const dispatch = useDispatch();

  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.asm?.e;
  });

  const auth = useSelector((state) => state?.auth?.user);

  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  const customerDomains = useSelector(
    (state) => state?.customer?.customerDomains?.data || []
  );

  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (orgId) {
      fetchSubDomains(orgId, dispatch, page, category, search, filterData, startDate, endDate, limit, domain);
    } else {
      fetchSubDomains(id, dispatch, page, category, search, filterData, startDate, endDate, limit, domain);
    }
  }, [id, dispatch, page, category, search, filterData, startDate, endDate, limit, domain]);

  // Manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  useEffect(() => {
    setTotalItems(subdomainCount?.totalResults);
  }, [subdomainCount?.totalResults]);


  useEffect(() => {
    // Fetch domains for the current client/organization
    if (id) {
      dispatch(fetchCustomerDomains(id));
    }
  }, [id, dispatch]);


  useEffect(() => {
    fetchSubDomainsTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    fetchSubDomainsGraph(id, dispatch);
  }, [id, dispatch]);

  let currentTableData = [];

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [expandedCiphers, setExpandedCiphers] = useState({});

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event == "") {
    }

    if (event == "riskAccepted") {
    }

    if (event == "markAsFalsePositive") {
    }

    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated for the selected subdomains?",
        type: "green", // Customize the dialog type as needed
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                subDomainIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              fetchSubDomainsAction(
                id,
                dispatch,
                page,
                category,
                search,
                filterData,
                data,
                domain
              );
              setSelectedValue("pleaseSelect");
              setActionNote("");
              setSelectedIds([]);
            },
          },
          cancel: function () {
            // User canceled, do nothing
          },
        },
      });
    }

  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: "resetAction",
      subDomainIds: selectedIds == 0 ? ids : selectedIds,
    };
    fetchSubDomainsAction(
      id,
      dispatch,
      page,
      category,
      search,
      filterData,
      data,
      domain
    );
    setSelectedIds([]);
  };

  const submit = () => {
    const data = {
      action: action,
      subDomainIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    fetchSubDomainsAction(
      id,
      dispatch,
      page,
      category,
      search,
      filterData,
      data,
      domain
    );
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    setSelectedIds([]);
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/expired-ssl-certificates/${id}/excel?domain=${domain}`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Expired and Vulnerable SSL.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  let oldDnsDetails = useSelector(
    (state) => state?.subDomain?.expiredGraph?.data
  );

  let ipArray = [];
  for (
    let details = 0;
    details < oldDnsDetails?.scanDetails?.length;
    details++
  ) {
    ipArray.push(oldDnsDetails?.scanDetails[details]);
  }

  let mapData = subdomains;

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }
  // Tooltip rebuild is no longer needed in react-tooltip v5+

  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };



  return (
    <>
      <style>{sliderStyles}</style>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <ReactTooltip />
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Vulnerable SSL Certificates</h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li className="breadcrumb-item active" aria-current="page">
                    Details
                  </li>
                </ol>
                <br />
              </nav>
              {/* <p>Vulberability Grade : {riskScore || "Calculating..."}</p>
              <p>Expiry Grade : {riskExpiryScore || "Calculating..."}</p> */}
            </div>
            <div className="col-md-6 col-sm-12 text-right hidden-xs d-flex justify-content-end">
              <span className="mr-2">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRecommendationModal(true);
                  }}
                  href="#"
                  className="btn btn-sm btn-primary mr-1"
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                  Recommendation
                </a>
              </span>
              {mapData?.length === 0 ? null : (
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    downloadFile();
                  }}
                  href="/add-report"
                  className="btn btn-sm btn-primary mr-1 download-report"
                >
                  Download Details
                </a>
              )}
            </div>
          </div>
        </div>

        {typeof scanCompleted !== "undefined" && !scanCompleted && (
          <div className="card border-success">
            <ScanMessage />
          </div>
        )}

        <div className="row clearfix">
          <div className="col-lg-12 col-md-8">
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("expired")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.totalExpiredSSls}
                        </h5>
                        <small className="text-muted">Expired</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("renewalin30days")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.totalSSLsWithRenewalIn30Days}
                        </h5>
                        <small className="text-muted">Renewal in 30 days</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("renewalin60days")}
                  >
                    <div className="row clearfix">
                      <div className="col-7">
                        <h5 className="mb-0">
                          {subdomainsTotals?.totalSSLsWithRenewalIn60Days}
                        </h5>
                        <small className="text-muted">Renewal in 60 days</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("renewalin90days")}
                  >
                    <div className="row clearfix">
                      <div className="col-7">
                        <h5 className="mb-0">
                          {subdomainsTotals?.totalSSLsWithRenewalIn90Days}
                        </h5>
                        <small className="text-muted">Renewal in 90 days</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("mismatched")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.mismatchedCertificateCount}
                        </h5>
                        <small className="text-muted">Mismatched Certificate</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("revoked")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.revokedCertificateCount}
                        </h5>
                        <small className="text-muted">Revoked Certificate</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("self_signed")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.selfSignedCertificateCount}
                        </h5>
                        <small className="text-muted">Self Signed Certificate</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("untrusted")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.untrustedCertificateCount || 0}
                        </h5>
                        <small className="text-muted">Untrusted Certificate</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("hasWeakCiphers")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.totalSubDomainsHavingCertificatesSupportingWeakCiphers}
                        </h5>
                        <small className="text-muted">SubDomains Supporting Weak Ciphers</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("hasOutdatedTlsVersions")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.totalSubDomainsHavingCertificatesWithOutdatedTlsVersion}
                        </h5>
                        <small className="text-muted">Subdomains with Outdated TLS Version</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                <div className="card mb-2">
                  <div
                    className="body"
                    style={{ cursor: "pointer" }}
                    onClick={() => executeScroll("pq_vulnerable")}
                  >
                    <div className="row clearfix">
                      <div className="col-12">
                        <h5 className="mb-0">
                          {subdomainsTotals?.pqVulnerableCount}
                        </h5>
                        <small className="text-muted">Post quantum vulnerable</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div className="row clearfix mt-3">
          <div className="col-lg-12 col-md-12">
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                  <li className="nav-item">
                    <a
                      className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("all");
                        setPage(1);
                        setfilterData("all");
                        setDomain("");
                        setSearch("");
                        setSelectedIds([]);
                      }}
                    >
                      Current
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("risk-accepted");
                        setPage(1);
                        setfilterData("all");
                        setDomain("");
                        setSearch("");
                        setSelectedIds([]);
                      }}
                    >
                      Risk Accepted
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("false-positive");
                        setPage(1);
                        setfilterData("all");
                        setDomain("");
                        setSearch("");
                        setSelectedIds([]);
                      }}
                    >
                      False Positive
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                        }`}
                      onClick={() => {
                        setCategory("remidiated");
                        setPage(1);
                        setfilterData("all");
                        setDomain("");
                        setSearch("");
                        setSelectedIds([]);
                      }}
                    >
                      Remediated
                    </a>
                  </li>
                </ul>
                <div className="card card_tableBox" ref={myRef}>
                  <div className="body">
                    <div className="header">
                      <div className="row">
                        <div className="col-sm-3 mb-2">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            value={filterData}
                            onChange={(e) => { setfilterData(e.target.value); setPage(1) }}
                          >
                            <option value="all">Vulnerable Status</option>
                            <option value="expired">Expired</option>
                            <option value="renewalin30days">
                              Renewal in 30 days
                            </option>
                            <option value="renewalin60days">
                              Renewal in 60 days
                            </option>
                            <option value="renewalin90days">
                              Renewal in 90 days
                            </option>
                            <option value="mismatched">Mismatched</option>
                            <option value="revoked">Revoked</option>
                            <option value="untrusted">Untrusted</option>
                            <option value="self_signed">Self Signed</option>
                            <option value="hasWeakCiphers">Weak Ciphers</option>
                            <option value="hasOutdatedTlsVersions">Outdated TLS Version</option>
                            <option value="pq_vulnerable">Post quantum vulnerable</option>
                          </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            value={search}
                            onChange={(e) => { setSearch(e.target.value); setPage(1) }}
                          >
                            <option value="">All Domains</option>
                            {customerDomains?.domains?.map((domain) => (
                              <option key={domain} value={domain}>
                                {domain}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <div
                            className="searchBoxInput p-0"
                          >
                            <input
                              class="form-control form-control-sm ml-0 my-1"
                              type="text"
                              placeholder="Search"
                              aria-label="Search"
                              value={search}
                              onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-sm-3 mb-2">
                          <div className="date-picker-container">
                            <div className="date-range-input">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Select date range"
                                value={formatDateRange()}
                                onClick={() => setDatePickerOpen(true)}
                                readOnly
                              />
                              <span className="calendar-icon">
                                <i className="fa fa-calendar" aria-hidden="true"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4 mb-2">
                          {selectedIds.length > 1 && category === "all" && (
                            <Box sx={{ width: 160 }}>
                              <FormControl fullWidth>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={selectedValue}
                                  onChange={(event) => {
                                    setAction(event.target.value);
                                    snooze("", event.target.value);
                                  }}
                                >
                                  <MenuItem value="pleaseSelect">
                                    Snooze Options
                                  </MenuItem>
                                  <MenuItem
                                    value="riskAccepted"
                                    onClick={() => {
                                      addModal();
                                    }}
                                  >
                                    Risk Accepted
                                  </MenuItem>
                                  <MenuItem
                                    value="markAsFalsePositive"
                                    onClick={() => {
                                      addModal();
                                    }}
                                  >
                                    False Positive
                                  </MenuItem>
                                  <MenuItem value="markAsRemidiated">
                                    Remediated
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Box>
                          )}
                          {selectedIds.length > 1 &&
                            (category == "false-positive" ||
                              category == "risk-accepted") && (
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed("")}
                              >
                                Unsnooze
                              </button>
                            )}
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-custom spacing5 mb-0">
                          <thead>
                            <tr>
                              {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th>
                                    <input
                                      type="checkbox"
                                      checked={
                                        selectedIds == 0 ? false : multiCheckTrue
                                      }
                                      onClick={() => {
                                        multicheck(currentTableData);
                                      }}
                                      className="checkUncheck"
                                    />
                                  </th>
                                )}
                              <th>Status</th>
                              <th>Sub-Domain Name</th>
                              <th>Expiry in</th>
                              <th>Serial Number</th>
                              <th>Vulnerabilties</th>
                              <th>Details</th>
                              {category !== "all" && <th>Action Note</th>}
                              <th>Created At</th>
                              <th>Updated At</th>
                              {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "all" ||
                                category === "risk-accepted" ||
                                category === "false-positive") && (
                                  <th style={{ width: "80" }}>Action</th>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {currentTableData?.map((row) => {
                              return (
                                <tr>
                                  {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                                    category === "risk-accepted" ||
                                    category === "false-positive") && (
                                      <td>
                                        <input
                                          onClick={() => singleClick(row?._id)}
                                          checked={selectedIds?.includes(
                                            row?._id
                                          )}
                                          type="checkbox"
                                          className="checkUncheck"
                                        />
                                      </td>
                                    )}
                                  <td>
                                    <span
                                      className={
                                        row?.status == "Active"
                                          ? "badge badge-success"
                                          : "badge badge-danger"
                                      }
                                    >
                                      {row?.status}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="text-warning">
                                      <a href={`https://${row.subDomainName}`} target="_blank" rel="noopener noreferrer">
                                        {row.subDomainName || 'NA'}
                                      </a>
                                    </span>
                                  </td>
                                  <td>
                                    {row?.status == "Expired" ? "Expired" : row?.expiresInDays + " days"}
                                  </td>
                                  <td>
                                    {row?.certificateSerialNumber || "NA"}
                                  </td>
                                  <td>
                                    <div>
                                      <div className="mb-1">
                                        <strong>{row?.status_vulnerability}</strong>
                                      </div>

                                      {/* Weak Ciphers Details - Only show when weak ciphers exist */}
                                      {row?.weakCiphers && row.weakCiphers.some(tlsVersion => tlsVersion.v && tlsVersion.v.length > 0) && (
                                        <div className="mt-2">
                                          <small className="text-muted">
                                            <strong>Weak Ciphers:</strong>
                                            {row.weakCiphers.map((tlsVersion, index) => (
                                              tlsVersion.v && tlsVersion.v.length > 0 && (
                                                <div key={index} className="ml-2 mt-1">
                                                  <span className="badge badge-warning mr-1" style={{ fontSize: '0.7em', padding: '2px 6px' }}>{tlsVersion.k.toUpperCase()}</span>
                                                  <span className="text-danger" style={{ fontWeight: '500' }}>
                                                    {tlsVersion.v.length} weak cipher{tlsVersion.v.length > 1 ? 's' : ''}
                                                  </span>
                                                  {tlsVersion.v.length <= 3 ? (
                                                    <div className="ml-3 mt-1">
                                                      {tlsVersion.v.map((cipher, cipherIndex) => (
                                                        <div key={cipherIndex} className="text-muted small" style={{ fontSize: '0.75em', lineHeight: '1.3' }}>
                                                          • {cipher}
                                                        </div>
                                                      ))}
                                                    </div>
                                                  ) : (
                                                    <div className="ml-3 mt-1">
                                                      <span
                                                        className="text-muted small"
                                                        style={{ fontSize: '0.75em', cursor: 'pointer', textDecoration: 'underline' }}
                                                        onClick={() => {
                                                          const expandedKey = `expanded_${row._id}_${index}`;
                                                          setExpandedCiphers(prev => ({
                                                            ...prev,
                                                            [expandedKey]: !prev[expandedKey]
                                                          }));
                                                        }}
                                                      >
                                                        • {tlsVersion.v[0]} + {tlsVersion.v.length - 1} more
                                                      </span>
                                                      {expandedCiphers[`expanded_${row._id}_${index}`] && (
                                                        <div className="ml-3 mt-1">
                                                          {tlsVersion.v.map((cipher, cipherIndex) => (
                                                            <div key={cipherIndex} className="text-muted small" style={{ fontSize: '0.75em', lineHeight: '1.3' }}>
                                                              • {cipher}
                                                            </div>
                                                          ))}
                                                        </div>
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            ))}
                                          </small>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-sm"
                                      onClick={() => {
                                        setSelectedRowDetails(row);
                                        setDetailsModal(true);
                                        setActiveTab('info');
                                      }}
                                      style={{
                                        backgroundColor: "#17a2b8",
                                        borderColor: "#17a2b8",
                                        color: "#fff",
                                        borderRadius: "4px",
                                        padding: "4px 12px",
                                        transition: "all 0.3s ease",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px"
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = "#138496";
                                        e.target.style.borderColor = "#117a8b";
                                        e.target.style.transform = "translateY(-1px)";
                                        e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = "#17a2b8";
                                        e.target.style.borderColor = "#17a2b8";
                                        e.target.style.transform = "translateY(0)";
                                        e.target.style.boxShadow = "none";
                                      }}
                                    >
                                      <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                                      <span className="details-slider-action-btn-text">Details</span>
                                    </button>
                                  </td>
                                  {category !== "all" && <td style={{ whiteSpace: "unset" }}>{row?.actionNote ? row.actionNote : "N/A"}</td>}
                                  <td style={{ whiteSpace: "unset" }}>
                                    {moment(row?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  <td style={{ whiteSpace: "unset" }}>
                                    {moment(
                                      row?.updatedAt || row?.createdAt
                                    ).format("DD-MM-YYYY")}
                                  </td>
                                  {row?.remediationPending == true ? <td>Retest in progress</td> : <>
                                    {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                                      <td>
                                        <Box sx={{ width: 160 }}>
                                          <FormControl fullWidth>
                                            {/* <InputLabel
                                          sx={{ color: "#fff" }}
                                          id="demo-simple-select-label"
                                        >
                                          Action
                                        </InputLabel> */}
                                            <Select
                                              labelId="demo-simple-select-label"
                                              id="demo-simple-select"
                                              value={selectedValue}
                                              onChange={(event) => {
                                                setAction(event.target.value);
                                                snooze(
                                                  row?._id,
                                                  event.target.value
                                                );
                                              }}
                                            >
                                              <MenuItem value="pleaseSelect">
                                                Snooze Options
                                              </MenuItem>
                                              <MenuItem
                                                value="riskAccepted"
                                                onClick={() => {
                                                  addModal();
                                                  setLookalikeAppId([row._id]);
                                                }}
                                              >
                                                Risk Accepted
                                              </MenuItem>
                                              <MenuItem
                                                value="markAsFalsePositive"
                                                onClick={() => {
                                                  addModal();
                                                  setLookalikeAppId([row._id]);
                                                }}
                                              >
                                                False Positive
                                              </MenuItem>
                                              <MenuItem value="markAsRemidiated">
                                                Remediated
                                              </MenuItem>
                                            </Select>
                                          </FormControl>
                                        </Box>
                                      </td>
                                    )}
                                  </>
                                  }
                                  {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" ||
                                    category === "false-positive") && (
                                      <td>
                                        <button
                                          className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                          onClick={() => Unsnoozed(row?._id)}
                                        >
                                          Unsnooze
                                        </button>
                                      </td>
                                    )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-between align-content-center">
                        <div className="dataTables_paginate">
                          {totalItems > 0 && (
                            <Pagination
                              className="pagination-bar"
                              currentPage={page}
                              totalCount={totalItems}
                              pageSize={limit}
                              onPageChange={(page) => setPage(page)}
                            />
                          )}
                        </div>
                        {totalItems > 10 && (
                          <select
                            value={limit}
                            onChange={(e) => {
                              setLimit(e.target.value)
                            }}
                            className="form-control limitSelectBox"
                          >
                            <option value={10}>10 per page</option>
                            <option value={25}>25 per page</option>
                            <option value={50}>50 per page</option>
                            <option value={100}>100 per page</option>
                          </select>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {datePickerOpen && (
          <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
            <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
              <div className="date-range-picker-header">
                {tempStartDate && tempEndDate
                  ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                  : "Select date range"}
              </div>
              <div className="date-range-calendars">
                <div>
                  <h6>From</h6>
                  <DatePicker
                    selected={tempStartDate}
                    onChange={(date) => {
                      setTempStartDate(date);
                      if (tempEndDate && date > tempEndDate) {
                        setTempEndDate(null);
                      }
                    }}
                    selectsStart
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <h6>To</h6>
                  <DatePicker
                    selected={tempEndDate}
                    onChange={(date) => setTempEndDate(date)}
                    selectsEnd
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    minDate={tempStartDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </div>
              <div className="date-range-actions">
                <button
                  className="date-range-apply"
                  onClick={applyDateRange}
                >
                  Apply Filter
                </button>
                <button
                  className="date-range-cancel"
                  onClick={cancelDateSelection}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SSL Certificate Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
          setActiveTab('info');
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-certificate mr-2"></i>
              SSL Certificate Details
              {selectedRowDetails?.subDomainName && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails.subDomainName}
                </span>
              )}
            </h5>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <button
                type="button"
                className="details-slider-close"
                onClick={() => {
                  setDetailsModal(false);
                  setSelectedRowDetails(null);
                  setActiveTab('info');
                }}
                aria-label="Close"
              >
                <i className="fa fa-times"></i>
              </button>
            </div>
          </div>
          <div className="details-slider-tabs">
            <button
              className={`details-slider-tab ${activeTab === 'info' ? 'active' : ''}`}
              onClick={() => setActiveTab('info')}
            >
              <i className="fa fa-info-circle mr-2"></i>
              Certificate Info
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {activeTab === 'info' && (
                  <>
                    {/* Certificate Information Section */}
                    <div className="details-section">
                      <div className="details-section-title">
                        <i className="fa fa-certificate"></i>
                        Certificate Information
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Valid From:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.valid_from
                            ? moment(selectedRowDetails.valid_from).format("DD-MM-YYYY HH:mm:ss")
                            : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Valid Till:</span>
                        <span className="details-info-value">
                          {selectedRowDetails?.valid_till
                            ? moment(selectedRowDetails.valid_till).format("DD-MM-YYYY HH:mm:ss")
                            : "N/A"}
                        </span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Issuer Organization:</span>
                        <span className="details-info-value">{selectedRowDetails?.issuer_org || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">TLS Version:</span>
                        <span className="details-info-value">{selectedRowDetails?.tls_version || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Sub-Domain:</span>
                        <span className="details-info-value">{selectedRowDetails?.subDomainName || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Serial Number:</span>
                        <span className="details-info-value">{selectedRowDetails?.certificateSerialNumber || "N/A"}</span>
                      </div>
                      <div className="details-info-item">
                        <span className="details-info-label">Status:</span>
                        <span className={`details-info-value ${selectedRowDetails?.status === "Active" ? "text-success" : "text-danger"}`}>
                          {selectedRowDetails?.status || "N/A"}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek has detected vulnerable and expired SSL/TLS certificates across one or
                  more subdomains. SSL misconfigurations directly impact confidentiality,
                  integrity, and trust, and are actively exploited by attackers and network
                  interceptors.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are Vulnerable & Expired SSL Certificates</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      SSL/TLS certificates secure data in transit between users and servers.
                      Certificates become a security risk when they are expired, revoked,
                      self-signed, mismatched, issued by untrusted authorities, or configured with
                      weak cryptographic parameters.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Issues Identified by BrandSek</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Expired certificates causing trust failures</li>
                      <li>Certificates nearing expiry (30/60/90 day risk windows)</li>
                      <li>Revoked or compromised certificates</li>
                      <li>Self-signed or untrusted certificate chains</li>
                      <li>Domain mismatch between certificate CN/SAN and hostname</li>
                      <li>Weak ciphers or outdated TLS versions</li>
                      <li>Post-quantum cryptographic exposure indicators</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Security & Business Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Man-in-the-Middle (MITM) attacks</li>
                      <li>Credential interception and session hijacking</li>
                      <li>Browser trust warnings and service disruption</li>
                      <li>Violation of PCI-DSS, ISO 27001, and CERT-In guidelines</li>
                      <li>Loss of customer trust and regulatory scrutiny</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Threat Landscape Context</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Attackers actively monitor expired and misconfigured certificates to exploit
                      unencrypted sessions, downgrade attacks, and impersonate legitimate services.
                      Post-quantum risks further increase long-term exposure for sensitive industries.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Certificate Remediation</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Renew all expired SSL certificates immediately</li>
                      <li>Revoke and replace compromised or revoked certificates</li>
                      <li>Fix domain mismatch (CN/SAN alignment)</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.8.20 · Cryptographic Controls</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Trust & Encryption Hardening</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Replace self-signed certificates with CA-issued certificates</li>
                      <li>Remove untrusted or legacy certificate chains</li>
                      <li>Enforce strong cipher suites only</li>
                    </ul>
                    <div className="compliance-tag">PCI-DSS 4.0 · Secure Transmission</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>TLS & Cryptography Configuration</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Disable outdated TLS versions (TLS 1.0 / 1.1)</li>
                      <li>Enforce TLS 1.2 or TLS 1.3</li>
                      <li>Review post-quantum cryptography readiness</li>
                    </ul>
                    <div className="compliance-tag">CERT-In TLS Security Advisory</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring & Lifecycle Management</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable certificate expiry alerts</li>
                      <li>Track renewal timelines (30/60/90 days)</li>
                      <li>Periodically audit SSL configurations</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.5.25 · Continuous Risk Management</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard5;
